module.exports = __webpack_public_path__ + "img/ic_next_default.c4a81e7c.svg";